import { z } from 'zod';
/**
 * App File Metadata Schema
 * Describes a file uploaded through the generic App Files API
 */ export const AppFileSchema = z.object({
    fileId: z.string(),
    appId: z.string(),
    name: z.string(),
    mimeType: z.string(),
    size: z.number().int().nonnegative(),
    uploadedBy: z.string(),
    createdAt: z.string()
});
/**
 * Upload App File Response Schema
 * POST /api/v2/apps/:appId/files (multipart, field `file`)
 */ export const UploadAppFileResponseSchema = z.object({
    file: AppFileSchema
});
/**
 * App File URL Response Schema
 * GET /api/v2/apps/:appId/files/:fileId/url
 */ export const AppFileUrlResponseSchema = z.object({
    url: z.string(),
    expiresIn: z.number().int().positive()
});
/**
 * Delete App File Response Schema
 * DELETE /api/v2/apps/:appId/files/:fileId
 */ export const DeleteAppFileResponseSchema = z.object({
    fileId: z.string()
});

//# sourceMappingURL=app-files.schema.js.map